import React from "react";
import { Box, CircularProgress, useTheme } from "@mui/material";
import { centered } from "../style/style";
export const WidgetLoader = ({ isLoading }) => {
    const theme = useTheme();
    return (React.createElement(React.Fragment, null, isLoading && (React.createElement(Box, { sx: Object.assign(Object.assign({}, centered), { height: "100%", width: "100%", gap: 2 }) },
        React.createElement(CircularProgress, { size: 48, thickness: 4, sx: {
                color: theme.palette.primary.main,
            } })))));
};
